module.exports = __webpack_public_path__ + "img/head.c8f3b48e.png";